import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { clearSpaceContentCountsAction } from '~src/spacesPlatform/actions/ContentCountsActions';
import { showContentTypes, toggleShowWorkbooksAsViews } from '~src/spacesPlatform/actions/ContentExplorerFilterActions';
import { selectCurrentlyApplicableContentTypes, selectDefaultContentTypeFilterValues } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectSelectedContentItems } from '~src/spacesPlatform/selectors/ContentSelectors';

import { ProjectSpace, ProjectSpaceDispatchProps, ProjectSpaceOwnProps, ProjectSpaceStateProps } from './ProjectSpace';

const mapStateToProps: MapStateToProps<ProjectSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  showWorkbooksAsViews: state.contentExplorer.showWorkbooksAsViews,
  urls: siteUrlsSelector(state),
  selectedContentItemsCount: _.values(selectSelectedContentItems(state)).length,
});

const mapDispatchToProps: MapDispatchToProps<ProjectSpaceDispatchProps> = (dispatch) => bindActionCreators({
  filterSelected: showContentTypes,
  toggleShowWorkbooksAsViews: toggleShowWorkbooksAsViews,
  clearContentCounts: clearSpaceContentCountsAction,
}, dispatch);

export const ConnectedProjectSpace: React.ComponentClass<ProjectSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(ProjectSpace);
